import React, { useState, useEffect } from 'react';
import {
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  TeamOutlined,
  UserAddOutlined,
  ClusterOutlined,
  AppstoreOutlined,
  ApartmentOutlined,
  AppstoreAddOutlined,
  SettingOutlined,
  UsergroupAddOutlined,
  GlobalOutlined
} from '@ant-design/icons';
import { Layout, Menu, theme } from 'antd';
import { Outlet } from 'react-router-dom';
import HeaderUserbox from '../Header/Userbox';
import HeaderNotifications from '../Header/HeaderNotifications';
import ThemeToggle from '@/components/ThemeToggle';
import { Box, Card, AppBar, Toolbar, IconButton, useMediaQuery, useTheme as useMuiTheme } from '@mui/material';
import logo from '../../images/logo/profile__2_-removebg-preview.png';
import logo11 from '../../images/logo/logo-H.svg';
import { useLocation, useNavigate } from "react-router-dom";
import Footer from '@/components/Footer';
import './sidebar.css';

const { Header, Sider, Content } = Layout;

const App: React.FC = () => {
  const {
    token: { colorBgContainer },
  } = theme.useToken();
  const muiTheme = useMuiTheme();
  const isMobile = useMediaQuery(muiTheme.breakpoints.down('md'));
  const navigate = useNavigate();
  const location = useLocation();
  const [collapsed, setCollapsed] = useState(isMobile);

  // Auto-collapse on mobile
  useEffect(() => {
    if (isMobile) {
      setCollapsed(true);
    }
  }, [isMobile]);

  const handleMenuClick = (e: any) => {
    navigate(e.key);
    if (isMobile) {
      setCollapsed(true);
    }
  };

  const sidebarWidth = collapsed ? 80 : 200;

  return (
    <div style={{ display: 'flex', minHeight: '100vh', width: '100vw', overflow: 'hidden' }}>
      {/* Mobile backdrop */}
      {isMobile && !collapsed && (
        <div
          className="mobile-backdrop"
          onClick={() => setCollapsed(true)}
        />
      )}

      {/* Sidebar */}
      <div
        className={`sidebar-wrapper ${collapsed ? 'collapsed' : 'expanded'}`}
        style={{
          transform: isMobile && collapsed ? 'translateX(-100%)' : 'translateX(0)',
          position: isMobile ? 'absolute' : 'fixed',
        }}
      >
        {/* Logo Section */}
        <div className={`logo-section ${collapsed ? 'collapsed' : 'expanded'}`}>
          <img
            className={`logo-image ${collapsed ? 'collapsed' : 'expanded'}`}
            // src={collapsed ? logo11 : logo}
            src={logo}
            alt="Huewine Logo"
          />
        </div>

        {/* Menu Section */}
        <div className={`menu-section ${collapsed ? 'collapsed' : 'expanded'}`}>
          <Menu
            theme="dark"
            mode="inline"
            onClick={handleMenuClick}
            selectedKeys={[location.pathname]}
            defaultSelectedKeys={["/management/profile/Registration"]}
            inlineCollapsed={collapsed}
            style={{
              borderRight: 0,
              backgroundColor: 'transparent',
              width: '100%',
            }}
            items={[
              {
                key: "/management/profile/Registration",
                icon: <UserAddOutlined />,
                label: "Employee",
              },
              {
                key: "configuration",
                icon: <SettingOutlined />,
                label: "Configuration",
                children: [
                  {
                    key: "/management/Configuration/Organization",
                    icon: <TeamOutlined />,
                    label: "Organization",
                  },
                  {
                    key: "/management/Configuration/Region",
                    icon: <GlobalOutlined />,
                    label: "Regional",
                  },
                  {
                    key: "/management/Configuration/Branch",
                    icon: <ClusterOutlined />,
                    label: "Branch",
                  },
                ],
              },
              {
                key: "application-setup",
                icon: <AppstoreOutlined />,
                label: "App Setup",
                children: [
                  {
                    key: "/management/Configuration/Application",
                    icon: <AppstoreOutlined />,
                    label: "Application",
                  },
                  {
                    key: "/management/Configuration/Category",
                    icon: <AppstoreAddOutlined />,
                    label: "Category",
                  },
                  {
                    key: "/management/Configuration/Entity",
                    icon: <ApartmentOutlined />,
                    label: "Entity",
                  },
                ],
              },
              {
                key: "/management/Configuration/UserRole",
                icon: <UsergroupAddOutlined />,
                label: "User Role",
              },
            ]}
          />
        </div>
      </div>

      {/* Main Content */}
      <div
        className="main-content"
        style={{
          marginLeft: isMobile ? 0 : `${sidebarWidth}px`,
          width: isMobile ? '100%' : `calc(100vw - ${sidebarWidth}px)`,
          maxWidth: isMobile ? '100vw' : `calc(100vw - ${sidebarWidth}px)`,
        }}
      >
        {/* 
        <Header
          style={{
            padding: '0 16px',
            background: '#fff', // use "transparent" or dark depending on theme
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: 64,
            // borderBottom: '1px solid #f0f0f0',
          }}
        > */}
        <Header
          style={{
            padding: '0 16px',
            background: '#fff',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            height: 64,
            position: 'fixed',      // 👈 fixed, won’t move
            top: 0,                 // 👈 lock to top
            left: isMobile ? 0 : `${sidebarWidth}px`, // offset for sidebar
            right: 0,
            zIndex: 1200,           // 👈 stays above everything
            boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
          }}
        >


          <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
            <IconButton
              onClick={() => setCollapsed(!collapsed)}
              style={{
                fontSize: '18px',
                cursor: 'pointer',
              }}
            >
              {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            </IconButton>
          </div>

          <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
            <HeaderNotifications />
            <ThemeToggle size="small" />
            <HeaderUserbox />
          </div>
        </Header>

        {/* Main Content Area */}
        <Box
          className="main-content-area"
          sx={{
            mt: '64px',  
            flex: 1,
            display: 'flex',
            flexDirection: 'column',
            gap: 2,     
          }}
        >
          <Card className="content-card">
            <Outlet />
          </Card>
          <Footer />
        </Box>
      </div>
    </div>
  );
};

export default App;